<template>
    <div class="page categoryMenuPage" v-if="menu" id="menuPage">
        <LocationBar />
        <transition
            enter-active-class="fadeInLeft"
            leave-active-class="fadeOutRight"
            mode="out-in"
        >
            <menu-list
                v-if="currentMenu.menu_items && currentMenu.menu_items.length"
                :menu-items="currentMenu.menu_items"
                style="animation-duration: 0.5s"
            />
            <menu-list
                v-else-if="search.query && $route.query.search"
                :menu-items="menu.findProductsByName(search.query)"
                style="animation-duration: 0.5s"
            />
            <category-menu
                v-else
                :menu="(currentMenu.subcategories && currentMenu.subcategories.length) ? currentMenu.subcategories : currentMenu"
                style="animation-duration: 0.5s"
            />
        </transition>
    </div>
</template>
<script>
    import CategoryMenu from "../../components/menu/CategoryMenu";
    import MenuList from "../../components/menu/MenuList";
    import LocationBar from "../../components/menu/LocationBar";
    import {mapState} from "vuex";
    import $ from 'jquery';
    
    export default {
        name: 'Menu',
        components: {LocationBar, MenuList, CategoryMenu},
        data() {
            return {
                catID: this.$route.query.category
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Our Menu", showBackButton: true, showBag: true});
            this.$store.dispatch("menu/getMenuCategories");
            if(!this.$store.state.shared.businessId /*|| this.$store.state.shared.businessId == 948*/ ){
                this.$router.push({name: "Locations"});
            }
        },
        computed: {
            ...mapState("menu", ["menu","search"]),
            currentMenu() {
                let menu = null;
                if (this.catID){
                    menu = this.menu.findCategoryById(this.catID)
                    this.$store.commit("shared/setTopBar", {title: menu.name, showBackButton: true, showBag: true});
                }else{
                    menu = this.menu;
                    this.$store.commit("shared/setTopBar", {title: "Our Menu", showBackButton: true, showBag: true});
                }
                return menu;
            }
        },
        watch: {
            '$route.query.category': function (val) {
                $('#menuPage').animate({
                    scrollTop: 0
                }, 500);
                this.catID = val
            }
        }
    }
</script>
